import { useEffect, useState, useRef } from "react";
import "./timer-counter-down.css";
import { formatTime } from "../../../../core/utils/helpers";

const TimerCounterDown = ({
  duration = 120,
  size = 110,
  strokeWidth = 8,
  isQuestionStarted,
  isQuestionStopped,
  setResponseTiming,
  setCurrentTimerTiming,
}) => {
  const [timeLeft, setTimeLeft] = useState(duration);
  const timerRef = useRef(null);

  // SVG math
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = duration > 0 ? timeLeft / duration : 0;
  const strokeDashoffset = circumference - progress * circumference;

  // Stroke color logic (from Timer 1)
  const getStrokeColor = () => {
    if (progress > 0.5) return "#4caf50";
    if (progress > 0.25) return "#ff9800";
    return "#f44336";
  };

  // Sync timer when duration changes
  useEffect(() => {
    setTimeLeft(duration);
  }, [duration]);

  // Timer logic (from Timer 2)
  useEffect(() => {
    if (isQuestionStarted && !isQuestionStopped) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    if (isQuestionStopped) {
      clearInterval(timerRef.current);
      setResponseTiming?.(timeLeft);
    }

    return () => clearInterval(timerRef.current);
  }, [isQuestionStarted, isQuestionStopped]);

  // Expose current timing to parent
  useEffect(() => {
    setCurrentTimerTiming?.(timeLeft);
  }, [timeLeft, setCurrentTimerTiming]);

  return (
    <div className="timer-container" style={{ width: "100%", height: "100%" }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          className="progress-ring-bg"
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />

        <circle
          className="progress-ring-circle"
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
          style={{
            stroke: getStrokeColor(),
            strokeDasharray: circumference,
            strokeDashoffset,
          }}
        />
      </svg>

      <div className="timer-text">
        {/* 00:00:{timeLeft < 10 ? "0" : ""}
        {timeLeft} */}
        {formatTime(timeLeft)}
      </div>
    </div>
  );
};

export default TimerCounterDown;
